import { Box } from "@shopify/polaris";
import React from "react";
import ShopifyModal from "../../../../components/ShopifyModal";

const Index = ({open,setFeedModal}) => {
    const handleOff = ()=>{
        let sendMsg = `Hello, I'm considering the 7-day trial but have some questions. Could you give me a quick overview of Dropshipman's benefits and how it can assist my dropshipping operations? Thanks!`

        try {
            window.Willdesk.show();
            window.Willdesk.chat(sendMsg);
        } catch (error) {
            console.info(error)
        }

        setFeedModal(false)
    }
  return (
    <div>
      <ShopifyModal
        id="feed-benefits-modal"
        open={open}
        onClose={() => {setFeedModal(false)}}
        heading="Some benefits for you"
        primaryAction={{
            content:"I'd Like to Know More About Plan",
            onAction:()=>{handleOff()}
        }}
      >
        <Box style={{fontSize:"16px",marginBottom:'16px',fontWeight:600}}>WAIT! Still Trying To Decide If Dropshipman Will Work For You?</Box>
        <p>We want to give you a detailed walk through of what Dropshipman can do, and answer your questions! Send us a message.</p>
      </ShopifyModal>
    </div>
  );
};

export default Index;
